export default __webpack_public_path__ + "static/media/databases.227c2538.png";